export { promptCreateCommand } from './v1/prompt_create';

import { promptCreateCommand } from './v1/prompt_create';

export const promptsCommands = [promptCreateCommand];
